"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classNames_1 = require("../../../utils/classNames");
const theme_1 = require("../../../utils/theme");
const Button_1 = require("../atoms/Button");
const Typography_1 = require("../atoms/Typography");
const AddressCard = ({ address, label, selectAddressOnClick, editAddressOnClick, className, editButtonLabel, }) => {
    const addressInfoTypographyElements = [
        `${address.firstName ?? ''} ${address.lastName ?? ''}`,
        `${address.streetName ?? ''}`,
        `${address.city ?? ''}, ${address.state ?? ''} ${address.postalCode ?? ''}`,
    ];
    const theme = (0, theme_1.useTheme)();
    const { addressCard } = theme.components;
    const editAddress = (e) => {
        e?.stopPropagation();
        editAddressOnClick && editAddressOnClick(address);
    };
    const selectAddress = (e) => {
        e?.stopPropagation();
        selectAddressOnClick && selectAddressOnClick(address);
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, classNames_1.cn)(addressCard.root, 'cursor-pointer rounded-md border border-neutral-400', className), onClick: selectAddress, children: (0, jsx_runtime_1.jsxs)("div", { className: (0, classNames_1.cn)(addressCard.contentWraper), children: [(0, jsx_runtime_1.jsx)(Typography_1.Typography, { tagName: "p", variant: "caption", className: (0, classNames_1.cn)(addressCard.labelWraper), children: label }), (0, jsx_runtime_1.jsx)("div", { className: (0, classNames_1.cn)(addressCard.address, 'flex flex-col'), children: addressInfoTypographyElements.map((element) => ((0, jsx_runtime_1.jsx)(Typography_1.Typography, { className: (0, classNames_1.cn)('text-base'), children: element }, element))) }), (0, jsx_runtime_1.jsx)(Button_1.Button, { onClick: editAddress, variant: "outlined", palette: "none", className: (0, classNames_1.cn)(addressCard.editButton, 'rounded-md border border-current'), children: editButtonLabel })] }) }, address.addressId));
};
exports.AddressCard = AddressCard;
